<div class="progress-bar" *ngIf="progressBarService.active" [ngClass]="{'toolbar': progressBarService.hasToolbar}">
    <mat-progress-bar [mode]="progressBarService.mode" [color]="progressBarService.color"></mat-progress-bar>
</div>